/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/auth";
import { useCart } from "../../context/cart";
import axios from "axios";
import MiniCart from "../../pages/MiniCart";
import LoginModalPopUp from "../../pages/LoginModalPopUp";
import { useWishlist } from "../../context/WishlistContext";
import GoogleReviews from "../../pages/GoogleReviews";
import GoogleReviewsCustom from "../../pages/GoogleReviewsCustom";
import { toast } from "react-toastify";
export default function Nav() {
  const { wishlist } = useWishlist();
  const [device, setDevice] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [auth, setAuth] = useAuth();
  const [cart_data] = useCart();
  const [searchVal, setSearchVal] = useState("");
  const [loader, setLoader] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [searchDropdown, setSearchDropdown] = useState(true);
  const [userId, setUserId] = useState(auth?.user?.id);
  const [show, setShow] = useState(false);
  const [searchHistoryInfo, setSerachHistoryInfo] = useState(
    JSON.parse(localStorage.getItem("searchHistoryInfo"))
      ? JSON.parse(localStorage.getItem("searchHistoryInfo"))
      : []
  );

  let active = {
    textDecoration: "underline",
  };

  let activeClassName = "active";
  let defoltClassName = "";

  const [isActive, setActive] = useState("false");

  const ToggleClass = () => {
    setActive(!isActive);
  };

  const handleLogout = async () => {
    setAuth({
      ...auth,
      user: null,
      token: "",
    });
    localStorage.removeItem("auth");
    localStorage.removeItem("country_data");
    localStorage.removeItem("country_currency");
    /* localStorage.removeItem("cart"); 
    http://hemant/chaashnicouture/api/v1/auth/logout' */
    localStorage.removeItem("cart");
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/logout?user=${userId}`
    );
    navigate(0);
    toast.success("Logout Successful!", {
      style: {
        background: "black",
        color: "white",
      },
    });
  };

  //Search Function by Sanjay
  const handleSearch = async (e) => {
    const searchData = await e.target.value;
    setKeyword(searchData);
    if (searchData) {
      setSearchDropdown(true);
      if (searchData.length >= 3) {
        setLoader(true);
        try {
          let { data } = await axios.get(
            `${process.env.REACT_APP_API_URL}/products/header-search?name=${searchData}`
          );
          if (data) {
            setLoader(false);
            setSearchVal(data);
          } else {
            //console.log(data);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setSearchVal("");
      }
    }
  };

  function desSplit(str) {
    const tags = /<[^>]*>/g;
    const output = str.replace(tags, "").substring(0, 150);
    return output + "...";
  }

  //handleSearchSubmit

  useEffect(() => {
    localStorage.setItem(
      "searchHistoryInfo",
      JSON.stringify(searchHistoryInfo)
    );
  }, [searchHistoryInfo]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (keyword.trim()) {
      let existingSearchItem = localStorage.getItem("searchHistoryInfo");
      if (!existingSearchItem.includes(keyword)) {
        setSerachHistoryInfo([...searchHistoryInfo, keyword]);
      }
      onBlur();
      navigate(`/search?q=${keyword}`);
    }
  };
  const delayedCloseMenu = () => {
    setTimeout(() => {
      setSearchDropdown(false);
    }, 200);
  };

  const onBlur = () => delayedCloseMenu();
  const onClick = () => setSearchDropdown(true);

  const [isMenuActive, setMenuActive] = useState("false");
  const ToggleMenu = () => {
    //alert("hi")
    setMenuActive(!isMenuActive);
  };

  const [menuCategory, setMenuCategory] = useState([]);


  const handelCatagory = (category) => {
    setMenuCategory(menuCategory === category ? [] : category);
  };

  // Add and Remove Class on scroll
  const [scrolltopdata, setscrolltopdata] = useState("");

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 5) {
        setscrolltopdata("");
      } else {
        setscrolltopdata("scrolled");
      }
    });
    if (location.hash === "#login") {
      setShow(true);
    } else {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    if (location.hash === "#login") {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [location]);
  useEffect(() => {
    // handelCatagory()
  }, [menuCategory]);
  //End responsive menu

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      if (width <= 200) {
        setDevice("mobile");
      } else if (width > 200 && width <= 1200) {
        setDevice("tablet");
      } else {
        setDevice("desktop");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [ismenuActive, setIsmenuActive] = useState(false);

  const handleClick = () => {
    setIsmenuActive(!ismenuActive);
  };
  const handleClickSearch = () => {
    setKeyword("");
    setSearchVal([]);
    setSearchDropdown(false);
  };

  const [isCartActive, setIsCartActive] = useState(false);

  const toggleCartClass = () => {
    setIsCartActive(!isCartActive);
  };


  const [googleReview, setGoogleReview] = useState(false);

  const GoogleHandleClick = () => {
    setGoogleReview(!googleReview)
  }


  return (
    <>
    <div className={isMenuActive ? "header-overlay" : "header-overlay active"} onClick={ToggleMenu}>
    <span className="close-cart">×</span>
    </div>
    <div className="mobile-header">
  <div className="container">
        <div className="header-logo">
      <div className="site-logo">
            <Link className="navbar-brand" to="/">
            <img
                  src="/images/logo-chaashnicouture.png"
                  width="181px"
                  height="50px"
                  alt="Chaashni by Maansi & Ketan"
                  title="Chaashni by Maansi & Ketan"
                  loading="lazy"
                /> {/*
            <div className="brand-box">A unit of M/s ANTYA</div>
            */}
            </Link>
          </div>
    </div>
        {device === "mobile" ||
        (device === "tablet" && (
        <div className="user-icons mobile-user-icons">
      <div className="cart"> <span onClick={toggleCartClass}> <i className="fa-solid fa-cart-shopping"></i> <span className="cart-count"> {`${cart_data ? "(" + cart_data.length + ")" : "0"}`} </span> </span> {/*
            <div className={isActive ? "minicart-box" : "minicart-box active"}>
            <MiniCart />
          </div>
      */}
      <MiniCart
                    isCartActive={isCartActive}
                    toggleCartClass={toggleCartClass}
                  />
    </div>
      </div>
  ))}
  <div className="burger-icon" onClick={ToggleMenu}> <a href="#" onClick={(e) => { e.preventDefault(); handleClick(); }}> <i className="fa fa-bars" aria-hidden="true"></i> </a> </div>
</div>
    </div>
    <nav
        datashow={ismenuActive ? "active" : ""}
        className={`${isMenuActive
          ? "navbar navbar-expand-lg bg-custom-white navbar-light fixed-top custom-menu new-design-nav"
          : "navbar navbar-expand-lg bg-custom-white navbar-light fixed-top custom-menu new-design-nav show-menu"
          } ${scrolltopdata}`}
      >
{/* JSON.stringify(auth,null,4) */}
<div className="container">
  <div className="collapse navbar-collapse" id="mynavbar">
    <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mynavbar"
            > <span className="navbar-toggler-icon"></span> </button>
    <ul className="navbar-nav">
      <li className={`nav-item `} >
        <NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName }
          onClick={ToggleMenu}
          to="/pages/our-story"
          style={{ textTransform: "uppercase" }}
          > Our Story</NavLink>
      </li>
      <li className={`nav-item `}><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName }
          onClick={ToggleMenu}
          to="/shop"
          style={{ textTransform: "uppercase" }}
          > Shop </NavLink>        
      </li>
      <li className={`nav-item ${menuCategory.includes("ready-to-ship") ? "open-sub-menu" : "" }`} style={{"display":"none"}} >
        <NavLink
                  className={({ isActive }) => isActive ? activeClassName : defoltClassName
          }
          onClick={ToggleMenu}
          to="/category/rts?orderBy=default&rts=1"
          style={{ textTransform: "uppercase" }}
          >
          Ready To Ship <i className="fa-solid fa-angle-down"></i> </NavLink>
        <ul className="submenu-box">
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?category_product=contemporary-indian-the-ruhani-edit_contemporary-indian-the-manchali-edit_contemporary-indian-the-glam-edit_contemporary-indian_ethnic-essentials_festive-flair&orderBy=default&rts=1"
              >
              Contemporary Indian {/* Indo Westerns */} </NavLink>
          </li>
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?category_product=lehengas_printed-lehengas_the-signature-edit_the-regal-collection_the-timeless-collection_the-sleek-edit_cocktail-lehengas_mermaid-lehengas&rts=1"
              >
              Lehengas </NavLink>
          </li>
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?category_product=lehenga-sarees&orderBy=default&rts=1"
              >
              Lehenga Sarees </NavLink>
          </li>
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?category_product=stitched-sarees&orderBy=default&rts=1"
              >
              Stitched Sarees </NavLink>
          </li>
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?category_product=sarees&orderBy=default&rts=1"
              >
              Sarees </NavLink>
          </li>
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?rts=1&category_product=gowns_gowns-signature-edit_gowns-the-timeless-collection"
              >
              Gowns </NavLink>
          </li>
          <li>
            <NavLink
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
              }
              onClick={ToggleMenu}
              to="/category/rts?orderBy=default&category_product=the-chic-edit&rts=1"
              >
              The Chic Edit (Westerns) </NavLink>
          </li>
        </ul>
        <span
                  className="menu-right-icon"
                  onClick={() => {
        handelCatagory("ready-to-ship");
        }}
        > <i className="fa-solid fa-angle-down"></i> </span> </li>
      <li className={`nav-item nav-stylist-button`} >
        <NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName }
          onClick={ToggleMenu}
          to="https://wa.me/+919873475454?text=Talk+To+a+Stylist"
          target="_blank"
          style={{ textTransform: "uppercase" }}
          >  Talk To a Stylist</NavLink>
      </li>
    </ul>
    <Link className="navbar-brand" to="/">
    <img
                src="/images/logo-chaashnicouture.png"
                width="181px"
                height="50px"
                alt="Chaashni Couture"
                title="Chaashni by Maansi & Ketan"
                loading="lazy"
              /> {/*
    <div className="brand-box">A unit of M/s ANTYA</div>
    */}
    </Link>
    <form className="d-flex searchform " onSubmit={handleSearchSubmit}>
      <input
                className={"form-control " + (loader ? "search-loader" : "")}
                type="text"
                placeholder="Search for Products and Categories"
                onChange={handleSearch}
                value={keyword}
                onBlur={onBlur}
                onClick={onClick}
                maxLength={100}
              />
      <span className="close-search-btn searchfordesktop" onClick={handleClick}>&times;</span> {keyword && (<span className="close-search-btn searchformobile" onClick={handleClickSearch}>&times;</span>)}
      
      {searchDropdown &&
      (searchVal?.products?.length > 0 ||
      searchVal?.category?.length > 0) && (
      <div className="search-result">
        <ul>
          {searchVal?.category?.map((sData, i) => {
          return (
          <li key={i}>
            <Link
                              target="_blank"
                              to={`/category/${sData.slug}`}
                            >
            <span className="search_result_content"> <span className="search_result_title"> {sData.name} </span> </span>
            </Link>
          </li>
          );
          })}
          {searchVal?.products?.map((sData, i) => {
          return (
          <li key={i}>
            <Link target="_blank" to={`/product/${sData.slug}`}>
            <span className="search_result_image"> <img
                                src={`${process.env.REACT_APP_IMAGE_URL}/product/thumbnail/${sData.thumbnail}`}
                                alt=""
                              /> </span> <span className="search_result_content"> <span className="search_result_title"> {sData.name} </span> <span className="search_result_sku"> SKU: {sData.code} </span> <span className="search_result_excerpt"> {desSplit(sData.details)} </span> </span>
            </Link>
          </li>
          );
          })}
        </ul>
      </div>
      )}
    </form>
    <div className="d-flex user-icons">
      <div className="talk-to-stylist">
        <NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName }
          onClick={ToggleMenu}
          to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_APPOINTMENT}?text=Talk+To+a+Stylist`}
          target="_blank"
          rel="noopener noreferrer"                 
          > Talk To a Stylist</NavLink>
      </div>
      <div className="insta-icon"><a href="https://www.instagram.com/chaashni.mk/" target="_blank"><i className="fa-brands fa-instagram"></i></a></div>
      <div className="search-icon"> <i
                className="fa-solid fa-magnifying-glass"
                onClick={handleClick}
              ></i> </div>
      <div className={`profile ${auth?.user ? "dropdown-icon" : ""} `}> {auth?.user ? (<span> <i className="fa-regular fa-user"></i>{" "} <span className="formobile"> {auth?.user?.name.split(" ")[0]} </span> </span>) : (
        <Link to="/loginsignup">
        <i className="fa-regular fa-user"></i>
        </Link>
        )}
        {auth?.user ? (
        <ul>
          <li className={({ isActive }) => isActive ? activeClassName : defoltClassName } >
            <NavLink onClick={ToggleMenu} to="/myorders"> <span>My Orders</span> </NavLink>
          </li>
          <li className={({ isActive }) => isActive ? activeClassName : defoltClassName } >
            <NavLink onClick={ToggleMenu} to="/measurements"> <span>My Measurements</span> </NavLink>
          </li>
          <li className={({ isActive }) => isActive ? activeClassName : defoltClassName } >
            <NavLink onClick={ToggleMenu} to="/my-account-detail"> <span>My Account details</span> </NavLink>
          </li>
          <li className={({ isActive }) => isActive ? activeClassName : defoltClassName } >
            <NavLink onClick={ToggleMenu} to="/my-address"> <span>My Address</span> </NavLink>
          </li>
          {/*
          <li
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
            }
            >
            <NavLink onClick={ToggleMenu} to="/support-ticket"> <span>Support Ticket</span> </NavLink>
          </li>
          */}
          <li style={{ display: "none" }}
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
            }
            >
            <NavLink onClick={ToggleMenu} to="/tryondetail"> <span>My AI Virtual Try-On</span> </NavLink>
          </li>
          <li
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
            }
            >
            <NavLink onClick={ToggleMenu} to="/checkout/"> <span>Checkout</span> </NavLink>
          </li>
          <li
                      className={({ isActive }) => isActive ? activeClassName : defoltClassName
            }
            >
            <Link
                        onClick={() =>
            {
            handleLogout();
            ToggleMenu();
            }}
            to="/"
            >
            Logout
            </Link>
          </li>
        </ul>
        ) : (
        ""
        )} </div>
      {auth?.user ? (
      <div className="wishlist">
        <Link to="/wishlist/">
        <i className="fa-regular fa-heart"></i> <span className="heart-count"> {` ${wishlist.length > 0 ? "(" + wishlist.length + ")" : ""
        }`} </span>
        </Link>
      </div>
      ) : (
      ""
      )}
      
      {device === "desktop" && (
      <div className="cart"> <span onClick={toggleCartClass}> <i className="fa-solid fa-cart-shopping"></i> <span className="cart-count"> {`${cart_data ? "(" + cart_data.length + ")" : "0"}`} </span> </span> {/*
        <div className={isActive ? "minicart-box" : "minicart-box active"}>
        <MiniCart />
      </div>
      */}
      <MiniCart
                    isCartActive={isCartActive}
                    toggleCartClass={toggleCartClass}
                  />
    </div>
    )} </div>
</div>
</div>
</nav>
<LoginModalPopUp show={show} handleClose={() =>
setShow(false)} />
<div className="google-review-button" style={{"display": "none"}} onClick={GoogleHandleClick}><span>★</span> Reviews</div>
{googleReview && (
<div className="google-reviews-wrap"> <span className="overlay" onClick={GoogleHandleClick}><span></span></span>
  <div className='google-reviews'>
    <div className='close-btn' onClick={GoogleHandleClick}>&times;</div>
    <GoogleReviews />
  </div>
  {/*
  <GoogleReviewsCustom />
  */} </div>
)}

    </>
  );
} 